import React from 'react';
import ShowGallery from '../components/Gallery';

const Portfolio = () => {
  return (
    <section className="portfolio page-section">
      <span className="section-label">Portfolio</span>
      <h1 className="section-heading">Valikoituja sarjoja</h1>
      <p className="section-subtitle">
        Kooste henkilökuvista, tapahtumista ja konseptuaalisista sessioista. Klikkaa mitä tahansa ruutua avataksesi kuvan
        muodossa, joka sopii editorial- ja kampanjakäyttöön.
      </p>
      <div className="glass-panel">
        <ShowGallery />
      </div>
    </section>
  );
};

export default Portfolio;
